import React from 'react';
import Safe from 'react-safe';
import getConfig from 'next/config';
import { useAppContext } from '../../store/appContext';
import { ZendeskScript } from './ZendeskScript';

const addAdrollScript = productDetails => (
  <>
    <Safe.script type="text/javascript">
      {`
                                adroll_adv_id = "LZCSRWVVCBFVJE766TJ3OB";
                                adroll_pix_id = "PVJIWP3OQZFJTH6XDLZ253";
                                (function() {
                                    var oldonload = window.onload;
                                    window.onload = function() {
                                        __adroll_loaded = true;
                                        var scr = document.createElement("script");
                                        var host = "https://s.adroll.com";
                                        scr.setAttribute('async', 'true');
                                        scr.type = "text/javascript";
                                        scr.src = host + "/j/roundtrip.js";
                                        ((document.getElementsByTagName('head') || [null])[0] ||
                                        document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
                                        if (oldonload) {
                                            oldonload()
                                        }
                                    };
                                }());
                            `}
    </Safe.script>
    {productDetails && (
      <Safe.script type="text/javascript">{`adroll_custom_data = ${JSON.stringify({
        product_id: productDetails.product.productVersionId,
        product_group: productDetails.adrollCustomData.product_group,
      })};`}</Safe.script>
    )}
  </>
);

const addGoogleTrackingTag = productDetails => (
  // Global site tag (gtag.js) - Google Ads
  <>
    <Safe.script type="text/javascript" src="https://www.googletagmanager.com/gtag/js?id=AW-765192859" />
    <Safe.script type="text/javascript">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-765192859');
      `}
    </Safe.script>
    {productDetails ? (
      <Safe.script type="text/javascript">
        {`
            gtag('event', 'page_view', {
              'send_to': 'AW-765192859',
              'items': [{
                'id': ${productDetails.product.productId},
                'google_business_vertical': 'retail'
              }]
            });
          `}
      </Safe.script>
    ) : null}
  </>
);

const TrackingScripts = () => {
  const {
    scripts: { riskifiedDomain, riskifiedSessionId },
    productDetails,
    runAdroll,
  } = useAppContext();
  const { publicRuntimeConfig } = getConfig();
  const { production } = publicRuntimeConfig;
  return (
    <>
      <Safe.script>
        {`
                (function() {
                    function riskifiedBeaconLoad() {
                        var store_domain = "${riskifiedDomain}";
                        var session_id = "${riskifiedSessionId}";
                        var url = ('https:' == document.location.protocol ? 'https://' : 'http://')
                            + "beacon.riskified.com?shop=" + store_domain + "&sid=" + session_id;
                        var s = document.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = url;
                        var x = document.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s, x);
                    }
                    if (window.attachEvent) {
                        window.attachEvent('onload', riskifiedBeaconLoad);
                    } else {
                        window.addEventListener('load', riskifiedBeaconLoad, false);
                    }
                })();
            `}
      </Safe.script>
      {production ? (
        <>
          <Safe.script>
            {`
                                var $embox_queue = [function () {
                                    new $embox(1148).hit();
                                }];
                                (function () {
                                    var s = document.createElement('script'), t = document.getElementsByTagName('script')[0];
                                    s.src = ('https:' == document.location.protocol ? 'https://tracking' : 'http://tools') + '.sembox.it/js/sembox-tracking-upgrade.js';
                                    t.parentNode.insertBefore(s, t);
                                }());
                            `}
          </Safe.script>
          <Safe.script type="text/javascript">
            {`
                                var google_conversion_id = 978756867;
                                var google_custom_params = window.google_tag_params;
                                var google_remarketing_only = true;
                            `}
          </Safe.script>
          <Safe.script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js" />
          <noscript>
            <div style={{ display: 'inline' }}>
              <img
                height="1"
                width="1"
                style={{ borderStyle: 'none' }}
                alt=""
                src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/978756867/?value=0&amp;guid=ON&amp;script=0"
              />
            </div>
          </noscript>
          {runAdroll && addAdrollScript(productDetails)}
          {addGoogleTrackingTag(productDetails)}
          <ZendeskScript />
        </>
      ) : null}
    </>
  );
};

export default TrackingScripts;
